const checkAddOnProgress = () => {
   const productAddOnEl = document.querySelector('.product-add-on');
  let currentCartPrice = document.querySelector('.subtotal .theme-money');
  const addOnBar = document.querySelector('.free-add-on-bar');
  const addOnThreshold = productAddOnEl.dataset.addOnThreshold;
  currentCartPrice = currentCartPrice.textContent.replace('$', '').replace('.', '').replace('USD', '').replaceAll(' ','');
  const currentThreshold = currentCartPrice / addOnThreshold;
  const cartPriceDifference = addOnThreshold - currentCartPrice;
  if (currentThreshold >= 1) {
    productAddOnEl.dataset.addOnProgress = 1;
    addOnBar.style.display = 'none';
  } else {
    productAddOnEl.dataset.addOnProgress = currentThreshold;
    // addOnBar.style.display = 'block';
    const addOnBarMessage = document.querySelector('.free-add-on-bar__message.free-add-on-bar__message--no');
    const spendMoreText = document.createElement('span');
    spendMoreText.textContent = `Spend `;
    
    const strong1 = document.createElement('strong');
    strong1.textContent = `$${(cartPriceDifference / 100).toFixed(2)}`;
    spendMoreText.appendChild(strong1);
    
    spendMoreText.appendChild(document.createTextNode(' more for '));
    
    const strong2 = document.createElement('strong');
    strong2.textContent = 'free product!';
    spendMoreText.appendChild(strong2);
    
    addOnBarMessage.appendChild(spendMoreText); 
  }
}

checkAddOnProgress();
document.addEventListener('on:cart:after-merge', (event) => {
  checkAddOnProgress();
});